/**
 * @description 是否是堆糖域名的图片
 * @param url
 * @returns
 */
const isDuitangImage = (url: string): boolean => {
  if (url && /^http(s)?:\/\/.*\.(duitang|dtstatic)\.com/.test(url.trim())) {
    return true;
  }
  return false;
};

export default isDuitangImage;
